// extracted by mini-css-extract-plugin
export var progress__bar = "newsBanner-module--progress__bar--wOSzt";
export var progress__container = "newsBanner-module--progress__container--M4Twf";
export var slider = "newsBanner-module--slider--GgPFf";
export var slider__background = "newsBanner-module--slider__background--xo8kV";
export var slider__currentVisualMobile = "newsBanner-module--slider__currentVisualMobile--z2F3+";
export var slider__main = "newsBanner-module--slider__main--Ur-qQ";
export var slider__mainContent = "newsBanner-module--slider__mainContent--CSGET";
export var slider__mainTitle = "newsBanner-module--slider__mainTitle--XSdSk";
export var slider__mainVisual = "newsBanner-module--slider__mainVisual--B2klU";
export var slider__nextVisual = "newsBanner-module--slider__nextVisual--HOShf";
export var thumbnail = "newsBanner-module--thumbnail--AoFxZ";
export var thumbnail__background = "newsBanner-module--thumbnail__background--ldTji";
export var thumbnail__cat = "newsBanner-module--thumbnail__cat--hfnIr";
export var thumbnail__container = "newsBanner-module--thumbnail__container--YjGVc";
export var thumbnail__content = "newsBanner-module--thumbnail__content--+QBDE";
export var thumbnail__number = "newsBanner-module--thumbnail__number--g3sPg";
export var thumbnail__title = "newsBanner-module--thumbnail__title--PIth-";